import React from 'react';
import '../../cards.css';
import { Label } from '@nooz-optics/nooz-components-lib';
import { Image } from '../../../Media/Image/index';
import { IImage, ILabel } from '../../../../../utils/types/contentful';

export interface CollectionWhiteUspHighlightCardProps {
  label: ILabel;
  subLabel?: ILabel;
  image: IImage;
}

export const CollectionWhiteUspHighlightCard = ({
  label,
  subLabel,
  image,
}: CollectionWhiteUspHighlightCardProps) => (
  <div className='cards w-full h-full relative border-b'>
    <div className='absolute top-0 h-full w-full' />
    <div
      className='absolute bg-opacity-0 h-full w-full bg-black backdrop-filter'
      aria-hidden='true'
    />
    <div className='absolute w-full h-1/2 inset-y-1/2 p-7 lg:p-9'>
      <div
        className={`relative flex flex-col ${
          subLabel ? 'justify-between' : 'justify-center'
        } h-full`}>
        <Label
          {...label}
          size='2xl'
          weight='bold'
        />
        {subLabel ? (
          <div className='mb-2'>
            <Label
              {...subLabel}
              size='base'
            />
          </div>
        ) : (
          <div />
        )}
      </div>
    </div>
    <div className='absolute -z-1 w-full h-full'>
      <Image
        {...image}
        bgColor='gray-200'
        objectFit='cover'
        height='50%'
        width='100%'
      />
      <div className='bg-white border-t w-full h-1/2' />
    </div>
  </div>
);
